import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import { useForm } from '../../lib/useForm';
import postObject from '../../lib/postObject';
import ImageUpload from '../../components/imageUpload';

const NotificationCreateModal = ({ closeMainModal, reload }) => {
  const [notification, handleChange] = useForm({ title: '', body: '' });
  const [image, setImage] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!notification.title) {
      setError('Please enter notification title');
      return false;
    }
    if (!notification.body) {
      setError('Please enter notification body');
      return false;
    }
    if (!image) {
      setError('Please select a notification image');
      return false;
    }
    return true;
  };

  const saveNotification = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('notifications', { ...notification, image });

      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create notification. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Notification</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveNotification(); }}>
          <Form.FieldSet>
            <Form.Input
              name='title'
              label='Title'
              placeholder='Enter notification title'
              value={notification['title']}
              onChange={handleChange}
              required
            />

            <Form.Textarea
              name='body'
              label='Body'
              placeholder='Enter notification body/content'
              value={notification['body']}
              onChange={handleChange}
              required
              rows={4}
            />

            <ImageUpload
              label="Notification Image"
              required
              uploadText="Click here to upload notification image"
              alt="Notification Preview"
              onChange={(value) => setImage(value)}
            />
          </Form.FieldSet>
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveNotification}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default NotificationCreateModal;
